import React, { useState, useEffect, useCallback, useMemo } from "react";
import queries from "../helpers/queries";
import caseQueries from "../helpers/caseQueries";
import {
    FiPaperclip ,
    FiTrash2,
} from "react-icons/fi";
import { useForm } from "react-hook-form";
import { withUser } from "../Contexts/user";
import { useSidebar } from "../Contexts/sidebar";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import _ from "lodash";
import Modal from "../Components/modal";
import moment from "moment";
import { useQuery, useMutation, useApolloClient } from "@apollo/react-hooks";
import excel from "../Components/excel";
import { useHistory } from "react-router-dom";

const statusOptions = [
    {
        label: "All",
        value: "all",
    },
    {
        label: "Bank Processing",
        value: "bankProcessing",
    },
    {
        label: "Draft",
        value: "draft",
    },
    {
        label: "Submitted",
        value: "submitted",
    },
    {
        label: "Loan Approved",
        value: "loanApproved",
    },
    {
        label: "Accepted",
        value: "accepted",
    },
    {
        label: "Rejected",
        value: "rejected",
    },
    {
        label: "Cancelled",
        value: "cancelled",
    },
    {
        label: "On Hold",
        value: "onhold",
    },
    {
        label: "Up-Front Reject",
        value: "upfrontReject",
    },
    {
        label: "KIV From Banker",
        value: "kivBanker",
    },
    {
        label: "Pickup Status",
        value: "pickupStatus",
    },
    {
        label: "KIV From Bank HQ",
        value: "kivBankerHQ",
    },
    {
        label: "Recommend From HQ",
        value: "recommendedHQ",
    },
];

const limitOptions = [
    {
        label: "Basic",
        value: 30,
    },
    {
        label: "Export",
        value: 9999,
    },
];

let timerId = null;
let borrowerTimerId = null;
let propertyAgentTimerId = null;

const DOC_TYPES = [
    "identity",
    "income",
    "salesform",
    "ccris",
    "others",
    "originalbankstatement",
    "bankapplicationform",
    "signedlo",
    "e-application",
];

const capitalizeWords = str => {
    return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
};

const NewCases = ({ location, user }) => {
    const { isDarkMode } = useSidebar();
    const history = useHistory();
    const [modalData, setModalData] = useState({});

    const handleRowClick = (caseData) => {

        // Open EditCase page in a new tab
        const url = `/cases/edit/${caseData._id}`;
        window.open(url, '_blank');
    };
    const [caseRemarksModalState, setCaseRemarksModalState] = useState(false);
    const [addNewRemarksModalState, setAddNewRemarksModalState] = useState(false);

    const [expandedDocs, setExpandedDocs] = useState(false);

    const apollo = useApolloClient();

    const initialFilters = useMemo(
        () => ({
            project: location.state
                ? location.state.projectName
                    ? location.state.projectName
                    : null
                : null,
            dateFrom: undefined,
            dateTo: undefined,
            submissionFrom: undefined,
            submissionTo: undefined,
            approvalFrom: undefined,
            approvalTo: undefined,
            signedFrom: undefined,
            signedTo: undefined,
            status: null,
            unitNumber: undefined,
            borrower: undefined,
            agent: null,
            pic: null,
            mdgAgent:
                user.auth.type === "user"
                    ? {
                          label: user.auth.name,
                          value: user.auth.userId,
                      }
                    : null,
            pd:
                user.auth.type === "pd"
                    ? {
                          label: user.auth.name,
                          value: user.auth.userId,
                      }
                    : null,
            sd:
                user.auth.type === "sd"
                    ? {
                          label: user.auth.name,
                          value: user.auth.userId,
                      }
                    : null,
            propertyAgent:
                user.auth.type === "agent" ? user.auth.name : undefined,
            shareholder:
                user.auth.type === "shareholder"
                    ? {
                          label: user.auth.name,
                          value: user.auth.userId,
                      }
                    : null,
            agency:
                user.auth.type === "admin"
                    ? {
                          label: "Admin Agency",
                          value: "6871c77aca89ac1a1f353d32",
                      }
                    : null,
            state: null,
            commStatus: null,
            firstBatchAlert: null,
            secondBatchAlert: null,
        }),
        [location.state, user.auth.name, user.auth.type, user.auth.userId]
    );
    const [filters, setFilters] = useState(initialFilters);

    const [formKey, setFormKey] = useState(0);

    const {
        register,
        errors,
        handleSubmit,
        getValues,
    } = useForm({
        defaultValues: {
            projectName: "",
            status: undefined,
            salesAgent: undefined,
            mdgAgent: undefined,
            propertyAgent: "",
            unitNumber: "",
            spaPrice: "",
            agency: "",
            remarks: "",
            state: undefined,

            // Property Details
            propertyAddress: "",
            propertyProjectName: "",
            propertyType: "",
            propertyCompleted: false,
            propertyBumi: undefined,
            propertyHold: undefined,
            propertyBuildup: "",
            propertyRenodetails: "",
            propertySpaPrice: "",
            propertyMargin: "",
            propertyLoanAmount: "",
            propertyLoanTenure: "",

            // Lawyer Firm
            lawyerSpaName: "",
            lawyerSpaLawyer: "",
            lawyerLaLawyer: "",
            lawyerRemarks: "",
        },
    });

    // Add the mutation for deleting a remark
    const [deleteRemark] = useMutation(caseQueries.DELETE_REMARK);

    const [paginationState, setPaginationState] = useState({
        limit: 30,
        page: 1,
        dir: "desc",
        by: "_id",
        totalPages: 0,
        documents: 0
    });
    

   

    const [debouncedFilters, setDebouncedFilters] = useState({
        unitNumber: "",
        borrower: "",
    });

    // Applied search variables - only updated when Search is clicked; used for fetchCases
    const initialAppliedSearchVariables = useMemo(
        () => ({
            unitNumber: "",
            borrower: "",
            dateFrom: undefined,
            dateTo: undefined,
            submissionFrom: undefined,
            submissionTo: undefined,
            approvalFrom: undefined,
            approvalTo: undefined,
            signedFrom: undefined,
            signedTo: undefined,
            project: location.state?.projectName
                ? location.state.projectName.value ?? location.state.projectName
                : null,
            agent: null,
            mdgAgent: user.auth.type === "user" ? user.auth.userId : null,
            state: null,
            status: null,
            agency:
                user.auth.type === "admin"
                    ? "6871c77aca89ac1a1f353d32"
                    : null,
            pic: null,
            pd: user.auth.type === "pd" ? user.auth.userId : null,
            sd: user.auth.type === "sd" ? user.auth.userId : null,
            propertyAgent:
                user.auth.type === "agent" ? user.auth.name : null,
            shareholder:
                user.auth.type === "shareholder" ? user.auth.userId : null,
        }),
        [location.state, user.auth.name, user.auth.type, user.auth.userId]
    );
    const [appliedSearchVariables, setAppliedSearchVariables] = useState(
        initialAppliedSearchVariables
    );

    const handleSearch = () => {
        setAppliedSearchVariables({
            unitNumber: filters.unitNumber ?? "",
            borrower: filters.borrower ?? "",
            dateFrom: filters.dateFrom,
            dateTo: filters.dateTo,
            submissionFrom: filters.submissionFrom,
            submissionTo: filters.submissionTo,
            approvalFrom: filters.approvalFrom,
            approvalTo: filters.approvalTo,
            signedFrom: filters.signedFrom,
            signedTo: filters.signedTo,
            project: filters.project ? filters.project.value : null,
            agent: filters.agent ? filters.agent.value : null,
            mdgAgent: filters.mdgAgent ? filters.mdgAgent.value : null,
            state: filters.state ? filters.state.value : null,
            status: filters.status ? filters.status.value : null,
            agency: filters.agency ? filters.agency.value : null,
            pic: filters.pic ? filters.pic.value : null,
            pd: filters.pd ? filters.pd.value : null,
            sd: filters.sd ? filters.sd.value : null,
            propertyAgent: filters.propertyAgent || null,
            shareholder: filters.shareholder ? filters.shareholder.value : null,
        });
        setPaginationState(prev => ({ ...prev, page: 1 }));
    };

    const {
        data: casesData,
        loading: casesLoading,
        refetch: refetchCases,
    } = useQuery(caseQueries.FETCH_CASES, {
        fetchPolicy: "network-only",
        variables: {
            limit: paginationState.limit,
            page: paginationState.page,
            by: paginationState.by ? paginationState.by : undefined,
            dir: paginationState.dir ? paginationState.dir : undefined,
            unitNumber: appliedSearchVariables.unitNumber,
            borrower: appliedSearchVariables.borrower,
            dateFrom: appliedSearchVariables.dateFrom,
            dateTo: appliedSearchVariables.dateTo,
            submissionFrom: appliedSearchVariables.submissionFrom,
            submissionTo: appliedSearchVariables.submissionTo,
            approvalFrom: appliedSearchVariables.approvalFrom,
            approvalTo: appliedSearchVariables.approvalTo,
            signedFrom: appliedSearchVariables.signedFrom,
            signedTo: appliedSearchVariables.signedTo,
            project: appliedSearchVariables.project,
            agent: appliedSearchVariables.agent,
            mdgAgent: appliedSearchVariables.mdgAgent,
            state: appliedSearchVariables.state,
            status: appliedSearchVariables.status,
            agency: appliedSearchVariables.agency,
            pic: appliedSearchVariables.pic,
            pd: appliedSearchVariables.pd,
            sd: appliedSearchVariables.sd,
            propertyAgent: appliedSearchVariables.propertyAgent,
            shareholder: appliedSearchVariables.shareholder,
        },
        onCompleted: ({ fetchCases: { pagination } }) => {
            setPaginationState(prev => ({
                ...prev,
                totalPages: pagination.totalPages,
                documents: pagination.documents
            }));
        },
    });

    // Sort cases to move rejected and cancelled to the end
    const sortedCasesData = React.useMemo(() => {
        if (!casesData?.fetchCases?.data) return null;
        
        const sorted = [...casesData.fetchCases.data].sort((a, b) => {
            const aIsRejectedOrCancelled = a.status === 'rejected' || a.status === 'cancelled';
            const bIsRejectedOrCancelled = b.status === 'rejected' || b.status === 'cancelled';
            
            // If both are rejected/cancelled or both are not, maintain original order
            if (aIsRejectedOrCancelled === bIsRejectedOrCancelled) {
                return 0;
            }
            
            // Move rejected/cancelled to the end
            return aIsRejectedOrCancelled ? 1 : -1;
        });
        
        return {
            ...casesData,
            fetchCases: {
                ...casesData.fetchCases,
                data: sorted
            }
        };
    }, [casesData]);

    const resetRemarksModal = () => {
        setCaseRemarksModalState(false);
        setModalData({});
    };

    const resetAddNewRemarksModal = () => {
        setAddNewRemarksModalState(false);
    };


    const [updateCaseRemarks] = useMutation(queries.UPDATE_CASE_REMARKS);



    const handleAddNewRemark = async () => {
        const formValues = getValues();
        
        await updateCaseRemarks({
            variables: {
                id: modalData._id,
                remarks: formValues.newRemark,
            },
            onError: ({ graphQLErrors, networkError }) => {
                if (graphQLErrors) {
                    for (const graphQLError of graphQLErrors) {
                        console.log(graphQLError);
                    }
                }

                if (networkError) {
                    console.log(networkError);
                }
            },
        });

        alert("New remark added successfully!");
        refetchCases();
        resetAddNewRemarksModal();
        
        // Update the modal data to show the new remark
        const updatedModalData = { ...modalData };
        if (!updatedModalData.remarks) {
            updatedModalData.remarks = [];
        }
        // Add new remark at beginning of array to show latest first
        updatedModalData.remarks.unshift({
            content: formValues.newRemark,
            createdAt: new Date().getTime().toString(),
            createdBy: {
                _id: user.auth.userId,
                name: user.auth.name,
            },
        });
        setModalData(updatedModalData);
    };


    const loadNfcAgents = useCallback(
        (val, callback) => {
            clearTimeout(timerId);
            timerId = setTimeout(async () => {
                const result = await apollo.query({
                    query: queries.FETCH_USERS,
                    variables: {
                        name: val,
                        status: "active",
                        limit: 9999,
                        page: 1,
                        type: "user",
                    },
                    fetchPolicy: "network-only",
                });

                callback(
                    result.data.fetchUsers.data.map((item) => ({
                        label: `${item.name}`,
                        value: item._id,
                    }))
                );
            }, 500);
        },
        [apollo]
    );

    const loadAgencies = useCallback(
        (val, callback) => {
            clearTimeout(timerId);
            timerId = setTimeout(async () => {
                const result = await apollo.query({
                    query: caseQueries.FETCH_AGENCIES,
                    variables: {
                        name: val,
                        limit: 9999,
                        page: 1,
                        pagination: {
                            limit: 9999,
                            page: 1,
                        },
                    },
                    fetchPolicy: "network-only",
                });

                callback(
                    result.data.fetchAgencies.data.map((item) => ({
                        label: `${item.name}`,
                        value: item._id,
                    }))
                );
            }, 500);
        },
        [apollo]
    );

    const loadActiveProjects = useCallback(
        (val, callback) => {
            clearTimeout(timerId);
            timerId = setTimeout(async () => {
                const result = await apollo.query({
                    query: queries.FETCH_PROJECTS,
                    variables: {
                        name: val,
                        status: "active",
                        limit: 9999,
                        page: 1,
                    },
                    fetchPolicy: "network-only",
                });

                callback(
                    result.data.fetchProjects.data.map((item) => ({
                        label: `${item.name}`,
                        value: item._id,
                    }))
                );
            }, 500);
        },
        [apollo]
    );

    const handleDeleteRemark = async (remarkId) => {
        try {
            if (
                !window.confirm(
                    "Are you sure you want to delete this remark?"
                )
            ) {
                return;
            }

            const result = await deleteRemark({
                variables: {
                    caseId: modalData._id,
                    remarkId: remarkId,
                },
            });

            if (result.data && result.data.deleteRemark) {
                // Update local state to immediately reflect the deletion in UI
                setModalData((prevData) => ({
                    ...prevData,
                    remarks: result.data.deleteRemark.remarks,
                }));

                alert("Remark deleted successfully");
                refetchCases(); // Refetch for data consistency
            }
        } catch (err) {
            console.error("Error deleting remark:", err);
            alert(
                "Failed to delete remark: " +
                    (err.message || "Unknown error")
            );
        }
    };

    // Main container - full width with small padding
    return (
        <div
            className={`min-h-screen ${
                isDarkMode ? "bg-gray-900" : "bg-gray-50"
            }`}
        >
            <div className="px-4 py-8">
            <div className="flex justify-between items-center mb-6">
                <h1 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : ''}`}>Cases</h1>
            </div>

            <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white'} rounded-lg shadow p-4 mb-6 border`} key={formKey}>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Case Date
                        </label>
                        <div className="relative">
                        <input
                            className={`w-full py-2 px-3 rounded-lg border text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                                isDarkMode 
                                    ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                    : 'bg-white border-gray-300 text-gray-900'
                            }`}
                                type="text"
                                placeholder="Select date range"
                                value={`${filters.dateFrom || ''} - ${filters.dateTo || ''}`}
                                onClick={(e) => {
                                    const calendar = e.target.nextElementSibling;
                                    if (calendar) {
                                        calendar.style.display = calendar.style.display === 'none' ? 'block' : 'none';
                                    }
                                }}
                            />
                            <div className={`absolute left-0 z-10 mt-1 shadow-lg rounded-lg p-2 border ${
                                isDarkMode ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-200'
                            }`} style={{ display: 'none' }}>
                                <div className="flex gap-4">
                                    <div>
                                        <div className={`text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>From</div>
                                        <input
                                            type="date"
                                            className={`w-full py-1 px-2 border rounded ${
                                                isDarkMode 
                                                    ? 'bg-gray-700 border-gray-600 text-white' 
                                                    : 'bg-white border-gray-300 text-gray-900'
                                            }`}
                                            value={filters.dateFrom || ''}
                                            onChange={(e) => {
                                                const value = e.target?.value || '';
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    dateFrom: value
                                                }));
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <div className={`text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>To</div>
                                        <input
                                            type="date"
                                            className={`w-full py-1 px-2 border rounded ${
                                                isDarkMode 
                                                    ? 'bg-gray-700 border-gray-600 text-white' 
                                                    : 'bg-white border-gray-300 text-gray-900'
                                            }`}
                                            value={filters.dateTo || ''}
                                            onChange={(e) => {
                                                const value = e.target?.value || '';
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    dateTo: value
                                                }));
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="flex justify-end mt-2 gap-2">
                                    <button
                                        className={`px-3 py-1 text-sm rounded ${
                                            isDarkMode 
                                                ? 'bg-gray-700 hover:bg-gray-600 text-gray-300' 
                                                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                                        }`}
                                        onClick={(e) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                dateFrom: '',
                                                dateTo: ''
                                            }));
                                            e.target.closest('.absolute').style.display = 'none';
                                        }}
                                    >
                                        Clear
                                    </button>
                                    <button
                                        className="px-3 py-1 text-sm bg-blue-400 text-white hover:bg-blue-600 rounded"
                                        onClick={(e) => {
                                            e.target.closest('.absolute').style.display = 'none';
                                        }}
                                    >
                                        Apply
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Submission Date
                        </label>
                        <div className="relative">
                        <input
                            className={`w-full py-2 px-3 rounded-lg border text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                                isDarkMode 
                                    ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                    : 'bg-white border-gray-300 text-gray-900'
                            }`}
                                type="text"
                                placeholder="Select date range"
                                value={`${filters.submissionFrom || ''} - ${filters.submissionTo || ''}`}
                                onClick={(e) => {
                                    const calendar = e.target.nextElementSibling;
                                    if (calendar) {
                                        calendar.style.display = calendar.style.display === 'none' ? 'block' : 'none';
                                    }
                                }}
                            />
                            <div className={`absolute left-0 z-10 mt-1 shadow-lg rounded-lg p-2 border ${
                                isDarkMode ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-200'
                            }`} style={{ display: 'none' }}>
                                <div className="flex gap-4">
                                    <div>
                                        <div className={`text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>From</div>
                                        <input
                                            type="date"
                                            className={`w-full py-1 px-2 border rounded ${
                                                isDarkMode 
                                                    ? 'bg-gray-700 border-gray-600 text-white' 
                                                    : 'bg-white border-gray-300 text-gray-900'
                                            }`}
                                            value={filters.submissionFrom || ''}
                                            onChange={(e) => {
                                                const value = e.target?.value || '';
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    submissionFrom: value
                                                }));
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <div className={`text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>To</div>
                                        <input
                                            type="date"
                                            className={`w-full py-1 px-2 border rounded ${
                                                isDarkMode 
                                                    ? 'bg-gray-700 border-gray-600 text-white' 
                                                    : 'bg-white border-gray-300 text-gray-900'
                                            }`}
                                            value={filters.submissionTo || ''}
                                            onChange={(e) => {
                                                const value = e.target?.value || '';
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    submissionTo: value
                                                }));
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="flex justify-end mt-2 gap-2">
                                    <button
                                        className={`px-3 py-1 text-sm rounded ${
                                            isDarkMode 
                                                ? 'bg-gray-700 hover:bg-gray-600 text-gray-300' 
                                                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                                        }`}
                                        onClick={(e) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                submissionFrom: '',
                                                submissionTo: ''
                                            }));
                                            e.target.closest('.absolute').style.display = 'none';
                                        }}
                                    >
                                        Clear
                                    </button>
                                    <button
                                        className="px-3 py-1 text-sm bg-blue-400 text-white hover:bg-blue-600 rounded"
                                        onClick={(e) => {
                                            e.target.closest('.absolute').style.display = 'none';
                                        }}
                                    >
                                        Apply
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Approval Date
                        </label>
                        <div className="relative">
                        <input
                            className={`w-full py-2 px-3 rounded-lg border text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                                isDarkMode 
                                    ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                    : 'bg-white border-gray-300 text-gray-900'
                            }`}
                                type="text"
                                placeholder="Select date range"
                                value={`${filters.approvalFrom || ''} - ${filters.approvalTo || ''}`}
                                onClick={(e) => {
                                    const calendar = e.target.nextElementSibling;
                                    if (calendar) {
                                        calendar.style.display = calendar.style.display === 'none' ? 'block' : 'none';
                                    }
                                }}
                            />
                            <div className={`absolute left-0 z-10 mt-1 shadow-lg rounded-lg p-2 border ${
                                isDarkMode ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-200'
                            }`} style={{ display: 'none' }}>
                                <div className="flex gap-4">
                                    <div>
                                        <div className={`text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>From</div>
                                        <input
                                            type="date"
                                            className={`w-full py-1 px-2 border rounded ${
                                                isDarkMode 
                                                    ? 'bg-gray-700 border-gray-600 text-white' 
                                                    : 'bg-white border-gray-300 text-gray-900'
                                            }`}
                                            value={filters.approvalFrom || ''}
                                            onChange={(e) => {
                                                const value = e.target?.value || '';
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    approvalFrom: value
                                                }));
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <div className={`text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>To</div>
                                        <input
                                            type="date"
                                            className={`w-full py-1 px-2 border rounded ${
                                                isDarkMode 
                                                    ? 'bg-gray-700 border-gray-600 text-white' 
                                                    : 'bg-white border-gray-300 text-gray-900'
                                            }`}
                                            value={filters.approvalTo || ''}
                                            onChange={(e) => {
                                                const value = e.target?.value || '';
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    approvalTo: value
                                                }));
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="flex justify-end mt-2 gap-2">
                                    <button
                                        className={`px-3 py-1 text-sm rounded ${
                                            isDarkMode 
                                                ? 'bg-gray-700 hover:bg-gray-600 text-gray-300' 
                                                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                                        }`}
                                        onClick={(e) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                approvalFrom: '',
                                                approvalTo: ''
                                            }));
                                            e.target.closest('.absolute').style.display = 'none';
                                        }}
                                    >
                                        Clear
                                    </button>
                                    <button
                                        className="px-3 py-1 text-sm bg-blue-400 text-white hover:bg-blue-600 rounded"
                                        onClick={(e) => {
                                            e.target.closest('.absolute').style.display = 'none';
                                        }}
                                    >
                                        Apply
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Signed Date
                        </label>
                        <div className="relative">
                        <input
                            className={`w-full py-2 px-3 rounded-lg border text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                                isDarkMode 
                                    ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                    : 'bg-white border-gray-300 text-gray-900'
                            }`}
                                type="text"
                                placeholder="Select date range"
                                value={`${filters.signedFrom || ''} - ${filters.signedTo || ''}`}
                                onClick={(e) => {
                                    const calendar = e.target.nextElementSibling;
                                    if (calendar) {
                                        calendar.style.display = calendar.style.display === 'none' ? 'block' : 'none';
                                    }
                                }}
                            />
                            <div className={`absolute left-0 z-10 mt-1 shadow-lg rounded-lg p-2 border ${
                                isDarkMode ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-200'
                            }`} style={{ display: 'none' }}>
                                <div className="flex gap-4">
                                    <div>
                                        <div className={`text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>From</div>
                                        <input
                                            type="date"
                                            className={`w-full py-1 px-2 border rounded ${
                                                isDarkMode 
                                                    ? 'bg-gray-700 border-gray-600 text-white' 
                                                    : 'bg-white border-gray-300 text-gray-900'
                                            }`}
                                            value={filters.signedFrom || ''}
                                            onChange={(e) => {
                                                const value = e.target?.value || '';
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    signedFrom: value
                                                }));
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <div className={`text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>To</div>
                                        <input
                                            type="date"
                                            className={`w-full py-1 px-2 border rounded ${
                                                isDarkMode 
                                                    ? 'bg-gray-700 border-gray-600 text-white' 
                                                    : 'bg-white border-gray-300 text-gray-900'
                                            }`}
                                            value={filters.signedTo || ''}
                                            onChange={(e) => {
                                                const value = e.target?.value || '';
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    signedTo: value
                                                }));
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="flex justify-end mt-2 gap-2">
                                    <button
                                        className={`px-3 py-1 text-sm rounded ${
                                            isDarkMode 
                                                ? 'bg-gray-700 hover:bg-gray-600 text-gray-300' 
                                                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                                        }`}
                                        onClick={(e) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                signedFrom: '',
                                                signedTo: ''
                                            }));
                                            e.target.closest('.absolute').style.display = 'none';
                                        }}
                                    >
                                        Clear
                                    </button>
                                    <button
                                        className="px-3 py-1 text-sm bg-blue-400 text-white hover:bg-blue-600 rounded"
                                        onClick={(e) => {
                                            e.target.closest('.absolute').style.display = 'none';
                                        }}
                                    >
                                        Apply
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Project Name
                        </label>
                        <AsyncSelect
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    borderColor: isDarkMode ? "#4B5563" : "#d1d5db",
                                    backgroundColor: isDarkMode ? "#374151" : "#ffffff",
                                    borderRadius: "0.5rem",
                                    minHeight: "38px",
                                    boxShadow: "none",
                                    "&:hover": {
                                        borderColor: "#3b82f6",
                                    },
                                }),
                                placeholder: (provided) => ({
                                    ...provided,
                                    color: isDarkMode ? "#9CA3AF" : "#6b7280",
                                    fontSize: "0.875rem",
                                }),
                                menu: (provided) => ({
                                    ...provided,
                                    backgroundColor: isDarkMode ? "#374151" : "#ffffff",
                                    borderColor: isDarkMode ? "#4B5563" : "#e2e8f0",
                                }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isSelected 
                                        ? (isDarkMode ? "#1F2937" : "#3B82F6")
                                        : state.isFocused
                                        ? (isDarkMode ? "#4B5563" : "#F3F4F6")
                                        : (isDarkMode ? "#374151" : "#ffffff"),
                                    color: state.isSelected 
                                        ? (isDarkMode ? "#D1D5DB" : "#ffffff")
                                        : (isDarkMode ? "#D1D5DB" : "#1F2937"),
                                }),
                                singleValue: (provided) => ({
                                    ...provided,
                                    color: isDarkMode ? "#D1D5DB" : "#1F2937",
                                }),
                            }}
                            cacheOptions
                            defaultOptions
                            loadOptions={loadActiveProjects}
                            value={filters.project}
                            placeholder="Select project"
                            isClearable={true}
                            onChange={(val) =>
                                setFilters((prev) => ({
                                    ...prev,
                                    project: val,
                                }))
                            }
                        />
                    </div>


                    {user.auth.type !== "agent" && (
                        <div>
                            <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Property Agent
                            </label>
                            <input
                                className={`w-full py-2 px-3 rounded-lg border text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                                    isDarkMode 
                                        ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                        : 'bg-white border-gray-300 text-gray-900'
                                }`}
                                type="text"
                                placeholder="Enter property agent name"
                                onChange={(e) => {
                                    const value = e.target.value;

                                    setFilters((prev) => ({
                                        ...prev,
                                        propertyAgent: value,
                                    }));

                                    clearTimeout(propertyAgentTimerId);
                                    propertyAgentTimerId = setTimeout(() => {
                                        setAppliedSearchVariables((prev) => ({
                                            ...prev,
                                            propertyAgent: value || null,
                                        }));
                                        setPaginationState((prev) => ({
                                            ...prev,
                                            page: 1,
                                        }));
                                    }, 500);
                                }}
                                value={filters.propertyAgent ?? ""}
                            />
                        </div>
                    )}
                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Unit Number
                        </label>
                        <input
                            className={`w-full py-2 px-3 rounded-lg border text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                                isDarkMode 
                                    ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                    : 'bg-white border-gray-300 text-gray-900'
                            }`}
                            type="text"
                            placeholder="Enter unit number"
                            onChange={(e) => {
                                e.persist();
                                const value = e.target.value;

                                setFilters((prev) => ({
                                    ...prev,
                                    unitNumber: value,
                                }));

                                clearTimeout(borrowerTimerId);
                                borrowerTimerId = setTimeout(() => {
                                    setDebouncedFilters((prev) => ({
                                        ...prev,
                                        unitNumber: value,
                                    }));
                                }, 500);
                            }}
                            value={filters.unitNumber}
                        />
                    </div>

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Borrower
                        </label>
                        <input
                            className={`w-full py-2 px-3 rounded-lg border text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                                isDarkMode 
                                    ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                    : 'bg-white border-gray-300 text-gray-900'
                            }`}
                            type="text"
                            placeholder="Enter borrower name"
                            onChange={(e) => {
                                e.persist();
                                const value = e.target.value;

                                setFilters((prev) => ({
                                    ...prev,
                                    borrower: value,
                                }));

                                clearTimeout(borrowerTimerId);
                                borrowerTimerId = setTimeout(() => {
                                    setDebouncedFilters((prev) => ({
                                        ...prev,
                                        borrower: value,
                                    }));
                                }, 500);
                            }}
                            value={filters.borrower}
                        />
                    </div>

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Status
                        </label>
                        <Select
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    borderColor: isDarkMode ? "#4B5563" : "#d1d5db",
                                    backgroundColor: isDarkMode ? "#374151" : "#ffffff",
                                    borderRadius: "0.5rem",
                                    minHeight: "38px",
                                    boxShadow: "none",
                                    "&:hover": {
                                        borderColor: "#3b82f6",
                                    },
                                }),
                                placeholder: (provided) => ({
                                    ...provided,
                                    color: isDarkMode ? "#9CA3AF" : "#6b7280",
                                    fontSize: "0.875rem",
                                }),
                                menu: (provided) => ({
                                    ...provided,
                                    backgroundColor: isDarkMode ? "#374151" : "#ffffff",
                                    borderColor: isDarkMode ? "#4B5563" : "#e2e8f0",
                                }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isSelected 
                                        ? (isDarkMode ? "#1F2937" : "#3B82F6")
                                        : state.isFocused
                                        ? (isDarkMode ? "#4B5563" : "#F3F4F6")
                                        : (isDarkMode ? "#374151" : "#ffffff"),
                                    color: state.isSelected 
                                        ? (isDarkMode ? "#D1D5DB" : "#ffffff")
                                        : (isDarkMode ? "#D1D5DB" : "#1F2937"),
                                }),
                                singleValue: (provided) => ({
                                    ...provided,
                                    color: isDarkMode ? "#D1D5DB" : "#1F2937",
                                }),
                            }}
                            isSearchable={false}
                            options={statusOptions}
                            value={filters.status}
                            placeholder="Select Status"
                            isClearable={true}
                            onChange={(val) =>
                                setFilters((prev) => ({
                                    ...prev,
                                    status: val,
                                }))
                            }
                        />
                    </div>

                    {user.auth.type === "superadmin" && (
                        <div>
                            <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                NFC Agent
                            </label>
                            <AsyncSelect
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        borderColor: isDarkMode ? "#4B5563" : "#d1d5db",
                                        backgroundColor: isDarkMode ? "#374151" : "#ffffff",
                                        borderRadius: "0.5rem",
                                        minHeight: "38px",
                                        boxShadow: "none",
                                        "&:hover": {
                                            borderColor: "#3b82f6",
                                        },
                                    }),
                                    placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#9CA3AF" : "#6b7280",
                                        fontSize: "0.875rem",
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        backgroundColor: isDarkMode ? "#374151" : "#ffffff",
                                        borderColor: isDarkMode ? "#4B5563" : "#e2e8f0",
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isSelected 
                                            ? (isDarkMode ? "#1F2937" : "#3B82F6")
                                            : state.isFocused
                                            ? (isDarkMode ? "#4B5563" : "#F3F4F6")
                                            : (isDarkMode ? "#374151" : "#ffffff"),
                                        color: state.isSelected 
                                            ? (isDarkMode ? "#D1D5DB" : "#ffffff")
                                            : (isDarkMode ? "#D1D5DB" : "#1F2937"),
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#D1D5DB" : "#1F2937",
                                    }),
                                }}
                                cacheOptions
                                defaultOptions
                                loadOptions={loadNfcAgents}
                                value={filters.mdgAgent}
                                placeholder="Select consultant"
                                isClearable={true}
                                onChange={(val) =>
                                    setFilters((prev) => ({
                                        ...prev,
                                        mdgAgent: val,
                                    }))
                                }
                            />
                        </div>
                    )}



                    {!["shareholder", "pd", "sd", "agent", "admin"].includes(user.auth.type) && (
                        <div>
                            <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                Agency
                            </label>
                            <AsyncSelect
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        borderColor: isDarkMode ? "#4B5563" : "#d1d5db",
                                        backgroundColor: isDarkMode ? "#374151" : "#ffffff",
                                        borderRadius: "0.5rem",
                                        minHeight: "38px",
                                        boxShadow: "none",
                                        "&:hover": {
                                            borderColor: "#3b82f6",
                                        },
                                    }),
                                    placeholder: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#9CA3AF" : "#6b7280",
                                        fontSize: "0.875rem",
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        backgroundColor: isDarkMode ? "#374151" : "#ffffff",
                                        borderColor: isDarkMode ? "#4B5563" : "#e2e8f0",
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isSelected 
                                            ? (isDarkMode ? "#1F2937" : "#3B82F6")
                                            : state.isFocused
                                            ? (isDarkMode ? "#4B5563" : "#F3F4F6")
                                            : (isDarkMode ? "#374151" : "#ffffff"),
                                        color: state.isSelected 
                                            ? (isDarkMode ? "#D1D5DB" : "#ffffff")
                                            : (isDarkMode ? "#D1D5DB" : "#1F2937"),
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        color: isDarkMode ? "#D1D5DB" : "#1F2937",
                                    }),
                                }}
                                cacheOptions
                                defaultOptions
                                loadOptions={loadAgencies}
                                value={filters.agency}
                                placeholder="Select Agency"
                                isClearable={true}
                                onChange={(val) =>
                                    setFilters((prev) => ({
                                        ...prev,
                                        agency: val,
                                    }))
                                }
                            />
                        </div>
                    )}

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Limit
                        </label>
                        <AsyncSelect
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    borderColor: isDarkMode ? "#4B5563" : "#d1d5db",
                                    backgroundColor: isDarkMode ? "#374151" : "#ffffff",
                                    borderRadius: "0.5rem",
                                    minHeight: "38px",
                                    boxShadow: "none",
                                    "&:hover": {
                                        borderColor: "#3b82f6",
                                    },
                                }),
                                placeholder: (provided) => ({
                                    ...provided,
                                    color: isDarkMode ? "#9CA3AF" : "#6b7280",
                                    fontSize: "0.875rem",
                                }),
                                menu: (provided) => ({
                                    ...provided,
                                    backgroundColor: isDarkMode ? "#374151" : "#ffffff",
                                    borderColor: isDarkMode ? "#4B5563" : "#e2e8f0",
                                }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isSelected 
                                        ? (isDarkMode ? "#1F2937" : "#3B82F6")
                                        : state.isFocused
                                        ? (isDarkMode ? "#4B5563" : "#F3F4F6")
                                        : (isDarkMode ? "#374151" : "#ffffff"),
                                    color: state.isSelected 
                                        ? (isDarkMode ? "#D1D5DB" : "#ffffff")
                                        : (isDarkMode ? "#D1D5DB" : "#1F2937"),
                                }),
                                singleValue: (provided) => ({
                                    ...provided,
                                    color: isDarkMode ? "#D1D5DB" : "#1F2937",
                                }),
                            }}
                            isSearchable={false}
                            defaultOptions={limitOptions}
                            placeholder="Select limit"
                            isClearable={true}
                            onChange={(val) =>
                                setPaginationState((prev) => ({
                                    ...prev,
                                    limit: val.value,
                                }))
                            }
                        />
                    </div>

                    <div className="flex flex-wrap items-end gap-2 mb-4 flex-shrink-0">
                    <button
                        type="button"
                        className={`px-4 py-2 rounded text-white whitespace-nowrap ${
                            isDarkMode
                                ? "bg-blue-600 hover:bg-blue-500"
                                : "bg-blue-500 hover:bg-blue-600"
                        }`}
                        onClick={handleSearch}
                    >
                        Search
                    </button>
                    <button
                        className={`px-4 py-2 rounded text-white whitespace-nowrap ${
                            isDarkMode
                                ? "bg-gray-600 hover:bg-gray-500"
                                : "bg-gray-500 hover:bg-gray-600"
                        }`}
                        onClick={() => {
                            // Reset filters to base state, including user-role defaults
                            setFilters(initialFilters);
                            setAppliedSearchVariables(
                                initialAppliedSearchVariables
                            );
                            setDebouncedFilters({
                                unitNumber: "",
                                borrower: "",
                            });
                            setPaginationState((prev) => ({
                                ...prev,
                                page: 1,
                            }));
                            // Force re-render of form to clear dropdowns
                            setFormKey(prev => prev + 1);
                        }}
                    >
                        Reset Filters
                    </button>

                        <button
                        className={`px-4 py-2 rounded text-white whitespace-nowrap ${
                            isDarkMode
                                ? "bg-green-600 hover:bg-green-500"
                                : "bg-green-500 hover:bg-green-600"
                        }`}
                        onClick={() => {
                            let payload = [];

                            sortedCasesData.fetchCases.data.forEach((x, i) => {
                                // Create a base row with all case data
                                const baseRow = {
                                    ReceivedDate: x.createdAt
                                        ? moment(parseInt(x.createdAt)).format(
                                              "DD-MM-YYYY"
                                          )
                                        : "—",
                                    SubmissionDate: x.submissionDate
                                        ? moment(
                                              (x.submissionDate)
                                          ).format("DD-MM-YYYY")
                                        : "—",
                                    ApprovalDate: x.approvalDate
                                        ? moment(
                                              (x.approvalDate)
                                          ).format("DD-MM-YYYY")
                                        : "—",
                                    SignedDate: x.signedDate
                                        ? moment(
                                              (x.signedDate)
                                          ).format("DD-MM-YYYY")
                                        : "—",
                                    Status: x.status,
                                    Borrower: "",
                                    Salary: "",
                                    ProjectName: x.project ? x.project.name : "—",
                                    Unit: x.unitNumber,
                                    SpaPrice: `RM ${x.propertyDetails.spaPrice}`,
                                    LoanAmount: `RM ${x.propertyDetails.loanAmount}`,
                                    Margin: `${x.propertyDetails.margin} %`,
                                    Agency: x.agency ? x.agency.name : "—",
                                    Agent: x.propertyDetails.propertyAgent,
                                    NFCAgent: x.mdgAgent
                                        .map((agent) => agent.name)
                                        .join(", "),
                                };

                                // Create a row for each borrower
                                x.borrower.forEach((borrower, borrowerIndex) => {
                                    if (borrowerIndex === 0) {
                                        // First borrower: include all case data
                                        payload.push({
                                            ...baseRow,
                                            Borrower: borrower.name,
                                            Salary: borrower.salary ? `RM ${borrower.salary}` : "",
                                        });
                                    } else {
                                        // Subsequent borrowers: only borrower name and salary, other fields empty
                                        payload.push({
                                            ReceivedDate: "",
                                            SubmissionDate: "",
                                            ApprovalDate: "",
                                            SignedDate: "",
                                            Status: "",
                                            Borrower: borrower.name,
                                            Salary: borrower.salary ? `RM ${borrower.salary}` : "",
                                            ProjectName: "",
                                            Unit: "",
                                            SpaPrice: "",
                                            LoanAmount: "",
                                            Margin: "",
                                            Agency: "",
                                            Agent: "",
                                            NFCAgent: "",
                                        });
                                    }
                                });
                            });

                            // Update row numbers sequentially
                            payload.forEach((item, index) => {
                                item.No = index + 1;
                            });

                            excel({
                                excelData: payload,
                                fileName: `Cases-Export`,
                            });
                        }}
                    >
                        Export
                    </button>
                    </div>
                </div>
            </div>


            {/* Update Table wrapper */}
            <div
                className={`${
                    isDarkMode ? "bg-gray-800 border-gray-700" : "bg-white"
                } rounded-lg shadow overflow-hidden border overflow-x-auto`}
            >
                {casesLoading ? (
                    <div className="flex flex-col items-center justify-center py-24 px-4">
                        <div className="relative w-16 h-16 mb-4">
                            <div className="absolute inset-0 border-4 border-orange-200 rounded-full"></div>
                            <div className="absolute inset-0 border-4 border-orange-500 rounded-full border-t-transparent animate-spin"></div>
                        </div>
                        <p className={`font-medium ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>Loading cases...</p>
                        <p className={`text-sm mt-1 ${isDarkMode ? "text-gray-500" : "text-gray-400"}`}>Please wait</p>
                    </div>
                ) : (
                <>
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="text-black">
                        <tr className="bg-orange-400">
                            <th className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider">
                                Date Status
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider">
                                Sales Type
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider">
                                Unit Number
                            </th>
                           
                            <th className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider">
                                Borrower Name
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider">
                                Project Name
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider">
                                Case Status
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider">
                                Docs Status
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider">
                            Remarks
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider">
                                Bank
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider">
                                Agency
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider">
                                Property Agent
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider">
                            NFC Agent(s)
                            </th>
                           
                        </tr>
                    </thead>
                    <tbody className="bg-blue-100 divide-y divide-gray-200">
                        {sortedCasesData && sortedCasesData.fetchCases.data.length > 0 ? (
                            sortedCasesData.fetchCases.data.map((row, idx) => (
                                <tr
                                    key={row._id || idx}
                                    className={
                                        user.auth.type === "admin"
                                            ? ""
                                            : "hover:bg-blue-200 cursor-pointer"
                                    }
                                    onClick={
                                        user.auth.type === "admin"
                                            ? undefined
                                            : () =>
                                                  !["pd", "sd", "agent", "shareholder"].includes(user.auth.type) &&
                                                  handleRowClick(row)
                                    }
                                >
                                    <td className="px-3 py-2 whitespace-nowrap text-sm" style={{minWidth: "180px"}} onClick={(e) => e.stopPropagation()}>
                                        <div className="min-h-[40px]">
                                            <div className="flex justify-between items-center border border-gray-200 rounded bg-white px-2 py-1">
                                                <span className="text-xs text-gray-800">
                                                    Case Date
                                                </span>
                                                <div className="flex items-center">
                                                    <span className={`ml-2 px-2 py-1 rounded text-xs font-semibold ${
                                                        row.createdAt ? "bg-blue-400 text-white" : "bg-gray-200 text-gray-800"
                                                    }`}>
                                                        {row.createdAt
                                                            ? moment(parseInt(row.createdAt)).format("YYYY-MM-DD")
                                                            : "None"}
                                                    </span>
                                                    <button
                                                        className="ml-2 text-xs text-gray-500 focus:outline-none"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setExpandedDocs((prev) => ({
                                                                ...prev,
                                                                [`dates-${row._id}`]: !prev[`dates-${row._id}`],
                                                            }));
                                                        }}
                                                    >
                                                        {expandedDocs[`dates-${row._id}`] ? "▲" : "▼"}
                                                    </button>
                                                </div>
                                            </div>
                                            {expandedDocs[`dates-${row._id}`] && (
                                                <div className="space-y-1 mt-1">
                                                    <div className="flex justify-between items-center border border-gray-200 rounded bg-white px-2 py-1">
                                                        <span className="text-xs text-gray-800">
                                                            Submission Date
                                                        </span>
                                                        <span className={`ml-2 px-2 py-1 rounded text-xs font-semibold ${
                                                            row.submissionDate ? "bg-blue-400 text-white" : "bg-gray-200 text-gray-800"
                                                        }`}>
                                                            {row.submissionDate
                                                                ? moment(row.submissionDate).format("YYYY-MM-DD")
                                                                : "None"}
                                                        </span>
                                                    </div>
                                                    <div className="flex justify-between items-center border border-gray-200 rounded bg-white px-2 py-1">
                                                        <span className="text-xs text-gray-800">
                                                            Approval Date
                                                        </span>
                                                        <span className={`ml-2 px-2 py-1 rounded text-xs font-semibold ${
                                                            row.approvalDate ? "bg-blue-400 text-white" : "bg-gray-200 text-gray-800"
                                                        }`}>
                                                            {row.approvalDate
                                                                ? moment(row.approvalDate).format("YYYY-MM-DD")
                                                                : "None"}
                                                        </span>
                                                    </div>
                                                    <div className="flex justify-between items-center border border-gray-200 rounded bg-white px-2 py-1">
                                                        <span className="text-xs text-gray-800">
                                                            Signed Date
                                                        </span>
                                                        <span className={`ml-2 px-2 py-1 rounded text-xs font-semibold ${
                                                            row.signedDate ? "bg-blue-400 text-white" : "bg-gray-200 text-gray-800"
                                                        }`}>
                                                            {row.signedDate
                                                                ? moment(row.signedDate).format("YYYY-MM-DD")
                                                                : "None"}
                                                        </span>
                                                    </div>
                                                   
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm">
                                        {row.salesType
                                            ? row.salesType.toUpperCase()
                                            : "-"}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm">
                                        {row.unitNumber}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm">
                                        {row.borrower && row.borrower.length > 0
                                            ? row.borrower
                                                  .map((b) => b.name)
                                                  .join(", ")
                                            : "-"}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm">
                                        {row.project ? row.project.name : "-"}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm" onClick={(e) => e.stopPropagation()}>
                                        <span
                                            className={`px-2 py-1 rounded text-xs font-semibold ${
                                                row.status === "loanApproved"
                                                    ? "bg-green-500 text-white"
                                                    : row.status === "accepted"
                                                    ? "bg-green-500 text-white"
                                                    : row.status === "cancelled"
                                                    ? "bg-red-500 text-white"
                                                    : row.status === "rejected"
                                                    ? "bg-purple-500 text-white"
                                                    : row.status === "submitted"
                                                    ? "bg-orange-500 text-white"
                                                    : row.status === "bankProcessing"
                                                    ? "bg-blue-400 text-white"
                                                    : row.status === "draft"
                                                    ? "bg-yellow-300 text-gray-800"
                                                    : "bg-gray-200 text-gray-800"
                                            }`}
                                        >
                                            {row.status
                                                ? _.startCase(row.status)
                                                : "-"}
                                        </span>
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm">
                                        {(() => {
                                            const docMap = {};
                                            if (
                                                row.document &&
                                                row.document.length > 0
                                            ) {
                                                row.document.forEach((doc) => {
                                                    // Normalize type for matching
                                                    let type = doc.type
                                                        .toLowerCase()
                                                        .replace(/\s|_/g, "");
                                                    if (
                                                        type === "salesform/otp"
                                                    )
                                                        type = "salesform";
                                                    if (
                                                        type ===
                                                        "original bank statement"
                                                    )
                                                        type =
                                                            "originalbankstatement";
                                                    if (
                                                        type ===
                                                        "bank application form"
                                                    )
                                                        type =
                                                            "bankapplicationform";
                                                    if (type === "bank kiv")
                                                        type = "bankkiv";
                                                    if (type === "signed lo")
                                                        type = "signedlo";
                                                    if (
                                                        type === "e-application"
                                                    )
                                                        type = "e-application";
                                                    docMap[type] = true;
                                                });
                                            }
                                            const docRows = DOC_TYPES.map(
                                                (type, idx) => (
                                                    <div
                                                        key={type}
                                                        className="flex justify-between items-center border border-gray-200 rounded bg-white px-2 py-1 mt-1 first:mt-0"
                                                    >
                                                        <span className="text-xs text-gray-800 uppercase">
                                                            {type
                                                                .replace(
                                                                    /-/g,
                                                                    " "
                                                                )
                                                                .replace(
                                                                    /([a-z])([A-Z])/g,
                                                                    "$1 $2"
                                                                )}
                                                        </span>
                                                        <span
                                                            className={`ml-2 px-2 py-1 rounded text-xs font-semibold ${
                                                                docMap[type]
                                                                    ? "bg-blue-400 text-white"
                                                                    : "bg-gray-200 text-gray-800"
                                                            }`}
                                                        >
                                                            {docMap[type]
                                                                ? "Submitted"
                                                                : "None"}
                                                        </span>
                                                    </div>
                                                )
                                            );
                                            const isExpanded =
                                                expandedDocs[row._id];
                                            return (
                                                <div
                                                    className="min-h-[40px] cursor-pointer hover:bg-blue-50 rounded p-1"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setModalData(row);
                                                    }}
                                                >
                                                    {docRows[0]}
                                                    {isExpanded && (
                                                        <div className="mt-1 space-y-1">
                                                            {docRows.slice(1)}
                                                        </div>
                                                    )}
                                                    <button
                                                        className="ml-2 text-xs text-gray-500 focus:outline-none"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setExpandedDocs(
                                                                (prev) => ({
                                                                    ...prev,
                                                                    [row._id]:
                                                                        !isExpanded,
                                                                })
                                                            );
                                                        }}
                                                    >
                                                        {isExpanded ? "▲" : "▼"}
                                                    </button>
                                                </div>
                                            );
                                        })()}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm" onClick={(e) => e.stopPropagation()}>
                                        <div className="flex justify-center items-center">
                                            <FiPaperclip  
                                                className="cursor-pointer hover:text-blue-600" 
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setModalData(row);
                                                    setCaseRemarksModalState(true);
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm">
                                        {(() => {
                                            const isExpanded = expandedDocs[row._id];
                                            return (
                                                <div
                                                    className="min-h-[40px] cursor-pointer hover:bg-blue-50 rounded p-1"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setModalData(row);
                                                    }}
                                                >
                                                    {row.bank[0] && (
                                                        <div className="flex justify-between items-center border border-gray-200 rounded bg-white px-2 py-1"  style={{minWidth: "150px"}}>
                                                            <span className="text-xs text-gray-800">
                                                                {row.bank[0].bankName}
                                                            </span>
                                                        </div>
                                                    )}
                                                    {isExpanded && row.bank.length > 1 && (
                                                        <div className="mt-1 space-y-1">
                                                            {row.bank.slice(1).map((b, i) => (
                                                                <div
                                                                    key={b._id || i}
                                                                    className="flex justify-between items-center border border-gray-200 rounded bg-white px-2 py-1"
                                                                >
                                                                    <span className="text-xs text-gray-800">
                                                                        {b.bankName}
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                    {row.bank.length > 1 && (
                                                        <button
                                                            className="ml-2 text-xs text-gray-500 focus:outline-none"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setExpandedDocs(
                                                                    (prev) => ({
                                                                        ...prev,
                                                                        [row._id]: !isExpanded,
                                                                    })
                                                                );
                                                            }}
                                                        >
                                                            {isExpanded ? "▲" : "▼"}
                                                        </button>
                                                    )}
                                                </div>
                                            );
                                        })()}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm">
                                        {row.agency ? row.agency.name : "-"}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm">
                                        {row.propertyAgent ? row.propertyAgent : row.propertyDetails ? row.propertyDetails.propertyAgent :  "-"}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm">
                                        {row.mdgAgent && row.mdgAgent.length > 0
                                            ? row.mdgAgent
                                                  .map((a) => capitalizeWords(a.name))
                                                  .join(", ")
                                            : "-"}
                                    </td>
                                   
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan={11}
                                    className="text-center py-8 text-gray-400"
                                >
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                
                {/* Pagination Controls */}
                {casesData && casesData.fetchCases.pagination && (
                    <div className={`px-4 py-3 flex items-center justify-between border-t ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
                        <div className="flex-1 flex justify-between items-center">
                            <div className={`text-sm ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                                Showing{' '}
                                <span className="font-medium">
                                    {((paginationState.page - 1) * paginationState.limit) + 1}
                                </span>
                                {' '}-{' '}
                                <span className="font-medium">
                                    {Math.min(paginationState.page * paginationState.limit, casesData.fetchCases.pagination.documents)}
                                </span>
                                {' '}of{' '}
                                <span className="font-medium">{casesData.fetchCases.pagination.documents}</span>
                                {' '}results
                            </div>
                            <div className="flex space-x-2">
                                <button
                                    onClick={() => setPaginationState(prev => ({ ...prev, page: 1 }))}
                                    disabled={paginationState.page === 1}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === 1
                                            ? isDarkMode
                                                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    First
                                </button>
                                <button
                                    onClick={() => setPaginationState(prev => ({ ...prev, page: prev.page - 1 }))}
                                    disabled={paginationState.page === 1}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === 1
                                            ? isDarkMode
                                                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    Previous
                                </button>
                                <span className={`px-3 py-1 rounded-md text-sm font-medium ${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-gray-100 text-gray-900"}`}>
                                    Page {paginationState.page} of {casesData.fetchCases.pagination.totalPages}
                                </span>
                                <button
                                    onClick={() => setPaginationState(prev => ({ ...prev, page: prev.page + 1 }))}
                                    disabled={paginationState.page === casesData.fetchCases.pagination.totalPages}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === casesData.fetchCases.pagination.totalPages
                                            ? isDarkMode
                                                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    Next
                                </button>
                                <button
                                    onClick={() => setPaginationState(prev => ({ ...prev, page: casesData.fetchCases.pagination.totalPages }))}
                                    disabled={paginationState.page === casesData.fetchCases.pagination.totalPages}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === casesData.fetchCases.pagination.totalPages
                                            ? isDarkMode
                                                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    Last
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                </>
                )}
            </div>

            {caseRemarksModalState && (
                <Modal reset={resetRemarksModal}>
                    <div className="container h-full mx-auto flex justify-center items-center">
                        <div className={`panel p-6 rounded-md max-w-4xl w-full ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
                            <div className="flex justify-between items-center mb-6">
                                <div className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                                    Case Remarks
                                </div>
                                <button
                                    onClick={() => setAddNewRemarksModalState(true)}
                                    className="px-4 py-2 bg-orange-400 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200"
                                >
                                    Add New Remarks
                                </button>
                            </div>
                            
                            <div className={`${isDarkMode ? 'bg-gray-700' : 'bg-gray-50'} rounded-lg p-4 max-h-96 overflow-y-auto`}>

                                {modalData.remarks && modalData.remarks.length > 0 ? (
                                    <div className="space-y-3">
                                        {modalData.remarks.map((remark, index) => (
                                            <div key={index} className={`rounded-lg p-3 border shadow-sm ${isDarkMode ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-200'}`}>
                                                <div className="flex justify-between items-start">
                                                    <div className="flex-1">
                                                        <p className={`text-sm whitespace-pre-wrap ${isDarkMode ? 'text-gray-300' : 'text-gray-800'}`}>
                                                            {remark.content || remark}
                                                        </p>
                                                    </div>
                                                    <div className={`text-xs ml-4 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                       {remark?.createdBy?.name}
                                                    </div>
                                                    <div className={`text-xs ml-4 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                        {moment(parseInt(remark.createdAt)).format("DD-MM-YYYY")}
                                                    </div>
                                                    {user.auth.type !== "manager" && (
                                                        <div className="ml-4">
                                                            <button
                                                                onClick={() => handleDeleteRemark(remark._id)}
                                                                className={`text-red-500 hover:text-red-700 p-1 rounded-full transition-colors duration-200 ${isDarkMode ? 'hover:bg-red-900' : 'hover:bg-red-50'}`}
                                                                title="Delete remark"
                                                            >
                                                                <FiTrash2 size={16} />
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className={`italic text-center py-8 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                        No remarks added yet. Click "Add New Remarks" to create one.
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
            {addNewRemarksModalState && (
                <Modal reset={resetAddNewRemarksModal}>
                    <div className="container h-full mx-auto flex justify-center items-center">
                        <div className={`panel p-6 rounded-md ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
                            <div className={`mb-4 text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                                Add New Remarks
                            </div>
                            <form
                                onSubmit={handleSubmit(handleAddNewRemark)}
                                className="lg:w-104"
                            >
                                <div className={`mb-2 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                    Content
                                </div>
                                <textarea
                                    name="newRemark"
                                    ref={register({
                                        required: true,
                                    })}
                                    placeholder="Enter your remarks here..."
                                    className={`w-full h-32 p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm ${
                                        isDarkMode 
                                            ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                            : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500'
                                    }`}
                                    rows="4"
                                />
                                {errors.newRemark && (
                                    <p className="text-red-400 text-xs mt-1">
                                        Remarks content is required
                                    </p>
                                )}
                                <div className="flex justify-end mt-4 space-x-2">
                                    <button
                                        type="button"
                                        onClick={resetAddNewRemarksModal}
                                        className={`px-4 py-2 text-sm font-medium rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 transition-colors duration-200 ${
                                            isDarkMode 
                                                ? 'text-gray-300 bg-gray-700 hover:bg-gray-600' 
                                                : 'text-gray-700 bg-gray-100 hover:bg-gray-200'
                                        }`}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="px-4 py-2 text-sm font-medium text-white bg-orange-400 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200"
                                    >
                                        Add Remarks
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal>
            )}
        
            </div>
        </div>
    );
};

export default withUser(NewCases);
